import { useSelector } from 'react-redux';
import { useCountryConfig } from './useCountryConfig';
import {
  LOCALE_MAP,
  formatDate,
  formatDateTime,
  formatCurrency,
  formatNumber,
  formatComplianceDate,
} from '../utils/locale-formatting';
import { DEFAULT_TIMEZONE } from '../utils/date_utils';

export const useLocaleFormatting = () => {
  const company = useSelector(state => state.auth.selectedTenant);
  const companyLocale = LOCALE_MAP[company?.defaultLanguage] ?? 'pt-BR';
  const companyTimezone = company?.timezone || DEFAULT_TIMEZONE;
  const { currency } = useCountryConfig(company?.country);
  const companyCurrency = currency || 'BRL';

  return {
    companyLocale,
    companyTimezone,
    companyCurrency,
    formatDate: (isoString, options) => formatDate(isoString, companyLocale, options),
    formatDateTime: (isoString) => formatDateTime(isoString, companyLocale, companyTimezone),
    formatCurrency: (amount, currencyOverride) =>
      formatCurrency(amount, companyLocale, currencyOverride || companyCurrency),
    formatNumber: (value, options) => formatNumber(value, companyLocale, options),
    formatComplianceDate: (isoString) => formatComplianceDate(isoString, companyLocale),
  };
};
